import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PublicHolidayService from "../Shared/Services/PublicHolidayService";
import { PublicHoliday } from "./Models/PublicHoliday";

export const ViewPublicHoliday = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [publicHoliday, setpublicHoliday] = useState<PublicHoliday>();

    useEffect(() => {
        getPublicHolidayId();
    }, []);

    const getPublicHolidayId = () => {
        PublicHolidayService.getById(id).then((response) => {
            setpublicHoliday(response.data);
        })
            .catch((error) => {
                console.log(`Error : Something went wrong while getting public holiday by id ${id}`, error)
            });
    }

    return (
        <>
            <div className="card card-default">
                <div className="card-header">
                    <h4>Public Holiday Details</h4>
                </div>
                <div className="card-body">
                    <div className="form-group row">
                        <label className="col-sm-3 control-label"><b>Name</b></label>
                        <div className="col-sm-9">
                            {publicHoliday?.name}
                        </div>
                    </div>
                    <br />
                    <div className="form-group row">
                        <label className="col-sm-3 control-label"><b>Date</b></label>
                        <div className="col-sm-9">
                            {publicHoliday?.date.split('T')[0].split('-').reverse().join('/')}
                        </div>
                    </div>
                    <br />
                    <div className="form-group row">
                        <label className="col-sm-3 control-label"><b>Country</b></label>
                        <div className="col-sm-9">
                            {publicHoliday?.countryName}
                        </div>
                    </div>
                    <br />
                    <div className="form-group row">
                        <div className=" col-sm-offset-3">
                            <a className="btn btn-secondary" onClick={() => navigate('/publicholidaylist')}>
                                Back
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}